const baseURL = 'https://catalogoblacksheep.soluditec.com/';

export default baseURL;
